
import React from 'react';
import { ArrowRightIcon } from './icons/ArrowRightIcon';

interface ReadyToGetStartedProps {
  onStartQuiz: () => void;
}

const ReadyToGetStarted: React.FC<ReadyToGetStartedProps> = ({ onStartQuiz }) => {
  return (
    <section className="py-16 sm:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-r from-[#2ECC40] to-[#0074D9] rounded-2xl shadow-xl p-12 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight">
            Ready to Get Started?
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg md:text-xl text-green-100">
            Take the first step toward financial freedom. Check your eligibility in under 5 minutes.
          </p>
          <div className="mt-10">
            <button
              onClick={onStartQuiz}
              className="bg-white text-[#0074D9] font-bold text-lg py-4 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center gap-2 mx-auto"
            >
              Check Your Eligibility Now
              <ArrowRightIcon className="w-5 h-5" />
            </button>
          </div>
          <p className="mt-6 text-sm text-green-100 opacity-80">
            No credit card required • 100% free assessment • Takes 5 minutes
          </p>
        </div>
      </div>
    </section>
  );
};

export default ReadyToGetStarted;
